import "./styles.css"

import { bindAudioControls, currentAudio, ensureAudio } from "./ui/audioControls"
import { htmlElement, selectElement } from "./ui/dom"
import { bindSonifier } from "./ui/sonifier"
import { startVisualizers } from "./ui/visuals"

function showPanel(panelName: string): void {
  for (const panel of document.querySelectorAll<HTMLElement>(".panel")) {
    const selected = panel.id === `panel-${panelName}`
    panel.hidden = !selected
    panel.classList.toggle("active", selected)
  }
  for (const tab of document.querySelectorAll<HTMLButtonElement>(".tab")) {
    const selected = tab.getAttribute("data-panel") === panelName
    tab.classList.toggle("active", selected)
    tab.setAttribute("aria-selected", String(selected))
  }
}

for (const tab of document.querySelectorAll<HTMLButtonElement>(".tab")) {
  tab.addEventListener("click", () => {
    const panelName = tab.getAttribute("data-panel")
    if (panelName !== null) showPanel(panelName)
  })
}

const mode = selectElement("generator-mode")
mode.addEventListener("change", () => {
  const spatial = mode.value === "spatial"
  htmlElement("spatial-controls").hidden = !spatial
  htmlElement("beat-controls").hidden = spatial
})

const stopAudioControls = bindAudioControls()
const stopVisualizers = startVisualizers(() => currentAudio()?.snapshot())
bindSonifier(ensureAudio)

for (const button of document.querySelectorAll<HTMLButtonElement>(".fullscreen-button")) {
  button.addEventListener("click", () => {
    const card = button.closest<HTMLElement>(".instrument-card")
    if (card === null) return
    const fullscreen = card.classList.toggle("fullscreen")
    button.setAttribute(
      "aria-label",
      fullscreen ? "Exit spectrum fullscreen" : "Enter spectrum fullscreen",
    )
  })
}

window.addEventListener("beforeunload", () => {
  stopVisualizers()
  stopAudioControls()
})
